import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { setupGlobalErrorHandlers } from './lib/error-handler'
import { setupChunkErrorHandler } from './lib/chunk-error-handler'

// Lightweight, synchronous setup (no network, no heavy libs)
setupGlobalErrorHandlers()
setupChunkErrorHandler()

// Mount React immediately — analytics initialize after first render
const mountApp = () => {
  const rootElement = document.getElementById('root');
  if (!rootElement) return;
  createRoot(rootElement).render(<App />);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', mountApp);
} else {
  mountApp();
}
